import { Dispatch } from "@reduxjs/toolkit";
import { setIdConnection } from "./authSlice";

import $ from 'jquery';
import { store } from "../../store";
import { PROJECTS_GET_TREE_FR, PROJECTS_GET_TREE_DE, PROJECTS_GET_TREE_PC, PROVIDERS_GET_COMPANIES, PROVIDERS_GET_DIMENSIONS, PROVIDERS_GET_ORIGINS, PROVIDERS_GET_PERIODS, PROVIDERS_GET_PROJECTS, PROVIDERS_GET_PROVIDERS, PROVIDERS_GET_PROVIDERS_DETAILS, PROVIDERS_GET_STATUS, TO_PAY_PERIOD_DELAY_DATA, TO_PAY_PERIOD_DELAY_DETAILS_DATA, TO_PAY_PERIOD_DELAY_PROVIDER_DETAILS_DATA, TO_PAY_PERIOD_DELAY_PROVIDERS_DATA, PROJECTS_GET_DETAILS, PROJECTS_GET_SUMMARY, PROJECTS_GET_PERIOD_GRAPH, PROJECTS_CLASSIFICATION_GET_DETAILS, PROJECTS_CLASSIFICATION_GET_PERIOD_GRAPH, PROJECTS_CLASSIFICATION_GET_SUMMARY, PROJECTS_GET_MEANS_TREE, PROJECTS_MEANS_GET_SUMMARY, PROJECTS_MEANS_GET_PERIOD_GRAPH, PROJECTS_MEANS_GET_DETAILS, PROJECTS_GET_MONTHLY_DET, PROJECTS_GET_MONTHLY_RES, PROJECTS_GET_DATES, PROFIT_GET_COMPANIES, PROFIT_GET_PROJECTS, PROFIT_GET_PROFIT, PROFIT_GET_PERIODS, PROFIT_GET_PC, PROFIT_GET_COINS } from "../../../constants/signalRequestConsts";
import { setCompaniesData, setDimensionsData, setOriginData, setPeriodsData, setPeriodsDelayData, setPeriodsDelayDetailsData, setPeriodsDelayProviderDetailsData, setPeriodsDelayProvidersData, setProjectsData, setProviderDetailsData, setProvidersData, setStatusData } from "../provider";
import { setClassificationDetails, setClassificationGraph, setClassificationSummary, setMeansTree, setProjectDetails, setProjectGraph, setProjectSummary, setResourceGraph, setResourceLowerDetail, setResourceSummary, setTreeDE, setTreeFR, setTreePC, setGraphModalList, setGraphModalResources, setDates } from "../projects";
import { setProfitCompaniesData, setProfitData, setProfitProjectsData, setPeriodsData as setProfitPeriodsData, setPCData, setProfitCoinsData } from "../profit";
import { setBoardProcessStatus, setBoardProcessExecute } from "../boardProcess";
import { BOARD_PROCESS_STATUS, BOARD_PROCESS_EXECUTE } from "../../../constants/signalRequestConsts";
import { S10Response } from "../../../interfaces/auth.interface";
// cleaned legacy projects imports

const parseSignalrData = (value: any) => {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    try {
        return JSON.parse(value);
    } catch (error) {
        console.warn('[BoardProcess] SignalR response is not valid JSON:', value);
        return null;
    }
};




interface JqueryInterface extends JQueryStatic {
    hubConnection?: any
}
declare global {
    interface Window {
        jQuery: JqueryInterface;
    }
}

const jsquery: JqueryInterface = $;

window.jQuery = jsquery;
require('signalr');


export const refreshToken = (token: string) => {
    const authState = store.getState().auth;
    return async (dispatch: Dispatch) => {
        var options = {
            qs: {
                AuthType: process.env.REACT_APP_AUTH_TYPE,
                Token: authState.token,
                ModuleId: authState.moduleId,
            }
        };
        const connection = jsquery.hubConnection(process.env.REACT_APP_SIGNALR_URL, options);
        const hubProxy = connection.createHubProxy(process.env.REACT_APP_SIGNALR_PROXY);

        hubProxy.on(process.env.REACT_APP_SIGNALR_RECEIVE, function (response: any) {
            const data = JSON.parse(response);
            console.log('data.Name', data.Name)
            const finalData: S10Response<any> = {
                // ...data,
                data: parseSignalrData(data.Data),
                count: data.Count,
                part: data.Part, 
                totalItems: data.OutputValue?.split("/")[1] ? Number(data.OutputValue?.split("/")[1]) : null,
            }
            switch (data.Name) {
                case PROVIDERS_GET_COMPANIES:
                    dispatch(setCompaniesData(finalData))
                    break
                case PROVIDERS_GET_PROJECTS:
                    dispatch(setProjectsData(finalData))
                    break
                case PROVIDERS_GET_PERIODS:
                    dispatch(setPeriodsData(finalData))
                    break
                case PROVIDERS_GET_STATUS:
                    dispatch(setStatusData(finalData))
                    break
                case PROVIDERS_GET_ORIGINS:
                    dispatch(setOriginData(finalData))
                    break
                case PROVIDERS_GET_PROVIDERS:
                    dispatch(setProvidersData(finalData))
                    break
                case PROVIDERS_GET_PROVIDERS_DETAILS:
                    dispatch(setProviderDetailsData(finalData))
                    break
                case PROVIDERS_GET_DIMENSIONS:
                    dispatch(setDimensionsData(finalData))
                    break
                case TO_PAY_PERIOD_DELAY_DATA:
                    dispatch(setPeriodsDelayData(finalData))
                    break
                case TO_PAY_PERIOD_DELAY_DETAILS_DATA:
                    dispatch(setPeriodsDelayDetailsData(finalData))
                    break
                case TO_PAY_PERIOD_DELAY_PROVIDERS_DATA:
                    dispatch(setPeriodsDelayProvidersData(finalData))
                    break
                case TO_PAY_PERIOD_DELAY_PROVIDER_DETAILS_DATA:
                    dispatch(setPeriodsDelayProviderDetailsData(finalData))
                    break



                case PROJECTS_GET_TREE_PC:
                    dispatch(setTreePC(finalData))
                    break
                case PROJECTS_GET_TREE_DE:
                    dispatch(setTreeDE(finalData))
                    break
                case PROJECTS_GET_TREE_FR:
                    dispatch(setTreeFR(finalData))
                    break
                // PROJECTS DATA
                case PROJECTS_GET_DETAILS:
                    dispatch(setProjectDetails(finalData))
                    break
                case PROJECTS_GET_SUMMARY:
                    dispatch(setProjectSummary(finalData))
                    break
                case PROJECTS_GET_PERIOD_GRAPH:
                    dispatch(setProjectGraph(finalData))
                    break

                // cLASSIFICATION DATA
                case PROJECTS_GET_MEANS_TREE:
                    dispatch(setMeansTree(finalData))
                    break
                case PROJECTS_CLASSIFICATION_GET_DETAILS:
                    dispatch(setClassificationDetails(finalData))
                    break
                case PROJECTS_CLASSIFICATION_GET_PERIOD_GRAPH:
                    dispatch(setClassificationGraph(finalData))
                    break
                case PROJECTS_CLASSIFICATION_GET_SUMMARY:
                    dispatch(setClassificationSummary(finalData))
                    break
                // MEANS DATA
                case PROJECTS_MEANS_GET_DETAILS:
                    dispatch(setResourceLowerDetail(finalData))
                    break
                case PROJECTS_MEANS_GET_PERIOD_GRAPH:
                    console.log(PROJECTS_MEANS_GET_PERIOD_GRAPH, finalData)
                    dispatch(setResourceGraph(finalData))
                    break
                case PROJECTS_MEANS_GET_SUMMARY:
                    console.log(PROJECTS_MEANS_GET_SUMMARY, finalData)
                    dispatch(setResourceSummary(finalData))
                    break

                // GRAPH MODAL DATA
                case PROJECTS_GET_MONTHLY_DET:
                    console.log(PROJECTS_GET_MONTHLY_DET, finalData)
                    dispatch(setGraphModalList(finalData))
                    break
                case PROJECTS_GET_MONTHLY_RES:
                    console.log(PROJECTS_GET_MONTHLY_RES, finalData)
                    dispatch(setGraphModalResources(finalData))
                    break
                case PROJECTS_GET_DATES:
                    console.log('PROJECTS_GET_DATES', finalData)
                    dispatch(setDates(finalData))
                    break

                // Profit
                case PROFIT_GET_COINS:
                    dispatch(setProfitCoinsData(finalData))
                    break
                case PROFIT_GET_COMPANIES:
                    dispatch(setProfitCompaniesData(finalData))
                    break
                case PROFIT_GET_PROJECTS:
                    dispatch(setProfitProjectsData(finalData))
                    break
                case PROFIT_GET_PROFIT:
                    dispatch(setProfitData(finalData))
                    break
                case PROFIT_GET_PERIODS:
                    dispatch(setProfitPeriodsData(finalData))
                    break;
                case PROFIT_GET_PC:
                    dispatch(setPCData(finalData))
                    break;

                case BOARD_PROCESS_STATUS:
                    console.log('[BoardProcess] SignalR response (BOARD_PROCESS_STATUS):', {
                        raw: data,
                        parsed: finalData.data,
                    })
                    dispatch(setBoardProcessStatus(finalData))
                    break;
                case BOARD_PROCESS_EXECUTE:
                    console.log('[BoardProcess] SignalR response (BOARD_PROCESS_EXECUTE):', {
                        raw: data,
                        parsed: finalData.data,
                    })
                    dispatch(setBoardProcessExecute(finalData))
                    break;

                default:
                    console.log(data.Name, finalData)
                    dispatch({
                        type: data.Name,
                        payload: {
                            ...data,
                            data: parseSignalrData(data.Data),
                            count: data.Count,
                            part: data.Part,
                        },
                    })
                    break;
            }
        });
        // connect
        connection
            .start()
            .done(function () {
                console.log("Now connected, connection ID=" + connection.id);
                dispatch(setIdConnection(connection.id));
            })
            .fail(function () {
                console.log("Could not connect");
                // dispatch(logout());
                // alert("Conexion fallida, posiblemente token vencido");
                // dispatch({
                // 	type: 'REFRESH_IDCONNECTION',
                // 	payload: false
                // });
            });
    }
}
